import uid from 'easy-uid';
import Discussion from './Discussion';

export default class InstanceRegistry {
	constructor() {
		this.instances = [];
	}

	getInstanceByInstanceId(instanceId) {
		for (let i = 0, { length } = this.instances; i < length; i++) {
			if (this.instances[i][1].instanceId === instanceId) {
				return this.instances[i][1];
			}
		}

		return null;
	}

	getAllInstances() {
		return this.instances.map(([_, instance]) => instance);
	}

	initializeDiscussionInstance(
		service,
		hostElement,
		config,
		authorizationTokenProvider
	) {
		const instanceId = uid();

		const instance = new Discussion(
			instanceId,
			service,
			hostElement,
			config,
			authorizationTokenProvider
		);
		this.instances.push([hostElement, instance]);

		return instance;
	}

	destroyDiscussionInstance(obsoleteInstance) {
		const instanceIndex = this.instances.findIndex(
			([_, instance]) => instance.instanceId === obsoleteInstance.instanceId
		);

		if (~instanceIndex) {
			this.instances.splice(instanceIndex, 1);
		}
	}
}
